<template lang='pug'>
  i.svg-icon.svg-icon-dialog
    svg(
      :fill='color'
      :width='`${size}px`'
      :height='`${size}px`'
      viewBox='0 0 100 100'
    )
      path(fill-rule='evenodd' clip-rule='evenodd' d='M18.168,92.615c-0.071,0-0.143,0-0.214,0c0-6.271,0-12.541,0-18.803 c-4.833-0.895-8.342-3.426-10.388-7.819c-0.533-1.146-0.804-2.412-1.196-3.624c0-13.872,0-27.744,0-41.616 c0.08-0.225,0.182-0.445,0.237-0.676c1.25-5.145,4.388-8.543,9.419-10.188c0.566-0.185,1.142-0.337,1.713-0.504 c21.881,0,43.762,0,65.642,0c0.186,0.075,0.366,0.178,0.558,0.222c4.714,1.086,8.025,3.853,9.866,8.319 c0.428,1.039,0.637,2.169,0.945,3.256c0,13.657,0,27.315,0,40.972c-0.062,0.12-0.158,0.234-0.182,0.362 c-1.317,6.958-6.66,11.398-13.723,11.399c-11.649,0.001-23.301-0.009-34.95,0.025c-0.624,0.002-1.343,0.225-1.856,0.578 c-7.643,5.272-15.26,10.581-22.876,15.891C20.146,91.118,19.166,91.879,18.168,92.615z M26.492,76.169 c0.49-0.324,0.78-0.511,1.063-0.707c4.548-3.16,9.08-6.34,13.655-9.458c0.569-0.388,1.36-0.637,2.049-0.64 c12.512-0.036,25.022-0.021,37.534-0.029c3.302-0.003,5.341-2.065,5.341-5.359c0.001-12.261,0.002-24.522-0.001-36.783 c-0.001-3.196-2.03-5.228-5.219-5.228c-20.232-0.001-40.465-0.001-60.698,0c-3.27,0-5.266,2.002-5.267,5.279 c0,12.153,0,24.307,0,36.461c0,3.692,1.925,5.63,5.598,5.633c1.957,0.001,3.915,0.001,5.945,0.001 C26.492,68.93,26.492,72.421,26.492,76.169z M39.395,43.531c-0.006-3.177-2.638-5.797-5.819-5.793 c-3.207,0.005-5.755,2.582-5.754,5.819c0.002,3.243,2.537,5.769,5.78,5.761C36.828,49.311,39.401,46.74,39.395,43.531z M56.773,43.507c-0.021-3.179-2.68-5.805-5.843-5.769c-3.221,0.036-5.738,2.602-5.732,5.843c0.006,3.233,2.557,5.754,5.805,5.737 C54.222,49.301,56.795,46.71,56.773,43.507z M73.69,43.576c0.015-3.189-2.578-5.813-5.77-5.837 c-3.187-0.025-5.799,2.569-5.811,5.772c-0.013,3.24,2.513,5.792,5.748,5.808C71.081,49.334,73.676,46.78,73.69,43.576z')


</template>

<script>
export default {

  props: {
    size: {
      type: Number,
      default: 20,
    },
    color: {
      type: String,
      default: '#009FA5',
    },
  },
};

</script>
